module.exports = __webpack_public_path__ + "img/error.0fee5fe.png";